import { GiftReceiptRequestStatus } from "@redotech/redo-model/gift-receipt/gift-receipt-request";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const updateGiftReceiptRequestStatus = {
  name: "updateGiftReceiptRequestStatus" as const,
  input: z.object({
    id: zExt.objectId(),
    status: createEnum(Object.values(GiftReceiptRequestStatus)),
  }),

  output: z.object({ success: z.boolean() }),
};
